<template>
  <div class="product-detail-footer-bar">
    <div class="product-detail-footer-bar-left">
      <div v-if="sell.status === 'unstart'"
           class="product-detail-footer-bar-left-text"
      >
        {{ sell.startTime }}{{ startHint }}
      </div>
      <template v-else-if="sell.status === 'canJoin'">
        <div class="product-detail-footer-bar-left-price">
          <span>{{ renderPrice.discount ? renderPrice.discount.price : renderPrice.originPrice }}
          </span>
          <span v-if="renderPrice.discount"
                class="origin-price"
          >{{ renderPrice.originPrice }}</span>
        </div>
        <div v-if="renderPrice.discount"
             class="product-detail-footer-bar-left-discount"
        >
          {{ renderPrice.discount.name }}
        </div>
      </template>
      <div v-else
           class="product-detail-footer-bar-left-text"
      >
        课程已售罄
      </div>
    </div>
    <div v-if="sell.status === 'unstart'"
         class="product-detail-footer-bar-right disabled"
    >
      即将上架
    </div>
    <div v-else-if="sell.status === 'canJoin'"
         class="product-detail-footer-bar-right"
         @click="handleAction"
    >
      {{ actionBtn.hint }}
    </div>
    <div v-else
         class="product-detail-footer-bar-right disabled"
         @click="handleClickDisabledBtn"
    >
      {{ disabledBtnText }}
    </div>
  </div>
</template>

<script>
  import { before, decorator } from 'ym-reporter-vue';
  import { informMe } from '@/services/app';
  import { getProductPath, projectJump } from '@/utils';
  import joinProductMixin from '@/mixins/order/joinProduct';
  import validator from '@/utils/validator';

  export default {
    name: 'ProductDetailFooterBar',
    mixins: [joinProductMixin],
    props: {
      sell: {
        type: Object,
        required: true,
      },
      startHint: {
        type: String,
        default: '开售',
      },
      product: {
        type: Object,
        required: true,
      },
      actionBtn: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      renderPrice: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      tabSelected: String,
    },
    data() {
      return {};
    },
    computed: {
      disabledBtnText() {
        const { sell } = this;
        const { status } = sell;
        if (status === 'goToNextProduct') {
          return '查看下一期';
        }
        return `设置${this.startHint}提醒`;
      },
    },
    methods: {
      async handleInformMe() {
        await informMe(this.product.id, this.product.type);
      },
      showNextProduct() {
        const { sell } = this;
        const { nextProductId } = sell;
        if (nextProductId && nextProductId > 0) {
          const { type } = this.product;
          const route = getProductPath(type, nextProductId);
          projectJump(route);
        }
      },
      handleClickDisabledBtn() {
        const { sell } = this;
        const { status } = sell;
        if (status === 'goToNextProduct') {
          this.showNextProduct();
          return;
        }
        this.handleInformMe();
      },
      @decorator(before(function () {
        this.$reporter.report('COURSE_DETAIL_ATONCE_BUYCOURSE_CLICK', { location: this.tabSelected });
      }))
      async handleAction() {
        window.sessionStorage.setItem('pay-origin-info', JSON.stringify({
          path: this.$route.fullPath,
          action: 'course-detail-purchase',
          location: this.tabSelected,
        }));
        await this.mixinHandleClickJoinBtn(this.actionBtn, 'joinProduct');
      },
    },
    created() {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-footer-bar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 40px 25px 60px;
    box-sizing: border-box;
    background-color: @color-white;
    &-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      &-price {
        display: flex;
        align-items: flex-end;
        span {
          line-height: 1;
          &:first-child {
            color: @color-black-dark;
            font-size: @font-size-extra-extra-large;
            font-weight: @font-weight-bold;
            &:before {
              content: '¥';
              font-size: @font-size-base;
            }
          }
          &.origin-price {
            position: relative;
            top: -2px;
            color: @color-text-lighter;
            font-size: @font-size-base;
            margin-left: 14px;
            text-decoration: line-through;
            &:before {
              content: '¥';
            }
          }
        }
      }
      &-text {
        color: @color-black-dark;
        font-size: @font-size-base;
        font-weight: @font-weight-bold;
      }
      &-discount {
        color: #ff0f0f;
        font-size: @font-size-small;
        line-height: 1;
        margin-top: 5px;
      }
    }
    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 288px;
      height: 100px;
      border-radius: 25px;
      background: linear-gradient(90deg, #48e4d8 0%, #02cccc 100%);
      color: #fff;
      font-size: 32px;
      font-weight: bold;
      &.disabled {
        color: #13b9bf;
        border: 1px solid #80c9c9;
        background: #f3fbfc;
      }
    }
  }
</style>
